import React from "react";

/**
 * A flat form section: heading + optional caption + content, rendered straight
 * on the page (no card box). Sub-sections are separated by a top border so the
 * register steps avoid nested "boxes in boxes".
 */
function FormBlock({ title, description, children, className = "" }) {
  return (
    <section
      className={`border-t border-gray-200 pt-8 first:border-t-0 first:pt-0 ${className}`}
    >
      {title && (
        <h3 className="text-base font-semibold tracking-tight text-fairblue-700">
          {title}
        </h3>
      )}
      {description && (
        <p className="mt-1 text-sm leading-relaxed text-gray-600">
          {description}
        </p>
      )}
      <div className={title || description ? "mt-5" : ""}>{children}</div>
    </section>
  );
}

export default FormBlock;
